import { genUUID, getCategoriesList, setArticle, updateArticle } from "../repositories/dataRetrieve";
import { Add, ArtTrack, Delete, PhotoCamera, Save } from "@mui/icons-material";
import { SnackBarMessage} from "../components/index";
import { Offcanvas } from "react-bootstrap";
import { useState, useEffect } from "react";
import { useFormik } from "formik";
import { CircularProgress,
		TextareaAutosize,
		ImageListItemBar,
		InputAdornment,
		OutlinedInput,
		ImageListItem,
		Typography,
		InputLabel,
		IconButton,
		ImageList,
		TextField,
		MenuItem,
		Select,
		Button,
		Stack,
		Grid } from "@mui/material";
import * as Yup from "yup";
import dayjs from "dayjs";
import "dayjs/locale/es";
dayjs.locale("es");

const AddArticle = ({ showOffCanvas, handleCloseOffCanvas, data }) => {
	const [snackSeverityArticle, setSnackSeverityArticle] = useState("success");
	const [snackMessageArticle, setSnackMessageArticle] = useState("");
	const [snackOpenArticle, setSnackOpenArticle] = useState(false);
	const [listCategories, setListCategories] = useState([]);
	const [selectedImages, setSelectedImages] = useState([]);
    const [hideDuration, setHideDuration] = useState(1000);
	const [articleReg, setArticleReg] = useState(null);
	const [loading, setLoading] = useState(false);
	const [edit, setEdit] = useState(false);

	const formik = useFormik({
		initialValues: {
			uuid: "",
			referencia: "",
			sku: "",
			descripcion_corta: "",
			descripcion_larga: "",
			linea: "",
			marca: "",
			precio_dept: "",
			descuento: "",
			existencias: "",
			vendidos: "",
			images: []
		},
		validateOnBlur: false,
        validateOnChange: false,
		validationSchema: Yup.object().shape({
			referencia: Yup.string().required("Se requiere de una clave de referencia para el registro."),
			sku: Yup.string().required("Se requiere de una clave SKU para el registro."),
			descripcion_corta: Yup.string().required("Se requiere de una descripción para el bien."),
			precio_dept: Yup.number().required("Se requiere de un precio para el bien."),
			descuento: Yup.number().optional(),
			Vendidos: Yup.number().optional(),
		}),
		onSubmit: async (values) => {
			setLoading(true);

			const dt = {
				'uuid': articleReg,
				'referencia': values?.referencia,
				'sku': values?.sku,
				'descripcion_corta': values?.descripcion_corta,
				'descripcion_larga': values?.descripcion_larga ?? "",
				'linea': values?.linea ?? "",
				'marca': values?.marca ?? "",
				'precio_dept': values?.precio_dept,
				'descuento': values?.descuento ?? "0",
				'existencias': values?.existencias ?? "0",
				'vendidos': values?.vendidos ?? "0",
				'images': selectedImages
            };

			if(edit && articleReg)
			{
				updateArticle(dt).then((r) => {
					if(r?.message.toUpperCase() === "OK")
					{
						setHideDuration(1000);
						setSnackSeverityArticle("success");
						setSnackMessageArticle("Se actualizó el artículo con éxito.");
						setSnackOpenArticle(true);
					}else{
						setHideDuration(4000);
						setSnackSeverityArticle("error");
						setSnackMessageArticle(`Ocurrió un error con la actualización del artículo. Error: ${r?.data}`);
						setSnackOpenArticle(true);
						setLoading(false);
					}
				}).catch((err) => {
					setHideDuration(4000);
					setSnackSeverityArticle("error");
					setSnackMessageArticle(`Ocurrió un error con la actualización del artículo. Error: ${err}`);
					setSnackOpenArticle(true);
					setLoading(false);
				});
			}else{
				setArticle(dt).then((r) => {
					if(r?.message.toUpperCase() === "OK")
					{
						setHideDuration(1000);
						setSnackSeverityArticle("success");
						setSnackMessageArticle("Se guardó el artículo con éxito.");
						setSnackOpenArticle(true);
					}else{
						setHideDuration(4000);
						setSnackSeverityArticle("error");
						setSnackMessageArticle(`Ocurrió un error con el guardado del artículo. Error: ${r?.data}`);
						setSnackOpenArticle(true);
						setLoading(false);
					}
				}).catch((err) => {
					setHideDuration(4000);
					setSnackSeverityArticle("error");
					setSnackMessageArticle(`Ocurrió un error con el guardado del artículo. Error: ${err}`);
					setSnackOpenArticle(true);
					setLoading(false);
				});
			}
		},
	});

	const handleNew = () => {
		setEdit(false);
		formik.handleReset();
		setSelectedImages([]);
	};

	const handleClose = () => {
		formik.handleReset();
		setEdit(false);
		setLoading(false);
		setSelectedImages([]);
		setArticleReg(null)
		handleCloseOffCanvas();
	};

	const handleBlur = (field) => {
		formik.setFieldTouched(field, true, true);
	};

	const handleImageChange = (e) => {
		let filesArray = [];

		if (e.target.files) {
			Array.from(e.target.files).map((el) => {
				if (el.size > 10 * 1024 * 1024) {
					setHideDuration(3000);
					setSnackSeverityArticle("error");
					setSnackMessageArticle(`El archivo "${el.name}" es demasiado pesado (máximo 10MB).`);
					setSnackOpenArticle(true);
				} else {
					filesArray.push({
						url: URL.createObjectURL(el),
						file: el
					});
				};
			});

			setSelectedImages((prevImages) => prevImages.concat(filesArray));
		}
	};

	const handleDelete = (index) => {
		setSelectedImages(selectedImages.filter((_, i) => i !== index));
	};

	const getCategories = async () => {
		try {
			const result = await getCategoriesList();

			if (result?.message.toUpperCase() === 'OK') {
				setListCategories(result?.data);
			} else {
				setListCategories([]);
			}
		} catch (error) {
			setSnackSeverityArticle("error");
			setSnackMessageArticle(`Error en la recuperación de la lista de categorías. Error: ${error}`);
			setSnackOpenArticle(true);
		}
	};

	useEffect(() => {
		if (data?.uuid) {
			setEdit(true);
			setArticleReg(data?.uuid);
			setSelectedImages(data?.images);
			formik.setValues({ uuid: data?.uuid,
								referencia: data?.referencia,
								sku: data?.sku,
								descripcion_corta: data?.descripcion_corta,
								descripcion_larga: data?.descripcion_larga,
								linea: data?.linea,
								marca: data?.marca,
								precio_dept: data?.precio_dept,
								descuento: data?.descuento,
								existencias: data?.existencias,
								vendidos: data?.vendidos,
								images: [] //revisar esto
							});
		} else {
			setArticleReg(genUUID());
		};

		getCategories();
	}, [data]);

	return (
		<Offcanvas
            placement="end"
            show={showOffCanvas}
            backdrop="true"
            onHide={() => {
                formik.handleReset();
                handleClose();
            }}
            style={{
                borderTopLeftRadius: "10px",
                top: "15%",
                height: "85%",
            }}
            className="resp-offCanvas"
		>
			<Offcanvas.Header closeButton>
				<Grid container sx={{ pt: "25px", px: "16px" }}>
                    <Grid item md={9} xs={8} sx={{ display: "flex", alignItems: "center" }}>
                        <ArtTrack className="me-1" fontSize="large" color='info' />
                        <Typography variant="h5" id="text-modal-header" sx={{ marginLeft: '1rem', display: { xs: 'none', md: 'flex' } }}>{edit ? "Modificar artículo" : "Nuevo registro"}</Typography>
                        <Typography variant="h6" id="text-modal-header" sx={{ marginLeft: '1rem', display: { xs: 'flex', md: 'none' } }}>{edit ? "Modificar artículo" : "Nuevo registro"}</Typography>
                    </Grid>
                    <Grid item md={3} xs={4} sx={{ textAlign: "right", display: 'flex', alignSelf: 'center' }}>
                        <InputLabel id="text-input-label">(*) Obligatorio</InputLabel>
                    </Grid>
                </Grid>
            </Offcanvas.Header>
			<Offcanvas.Body>
				<Grid container justifyContent="space-between" columnSpacing="10px" sx={{ px: "16px", width: '80%', justifySelf: 'center' }}>
					{
						edit ??
							<Grid item xs={12} id="uuid-group" sx={{ mt: "4px", mb: "2px" }}>
								<InputLabel id="text-input-label">ID</InputLabel>
								<TextField
									name="uuid"
									size="small"
									disabled
									sx={{ width: "100%" }}
									value={formik.values.uuid}
								/>
							</Grid>
                    }
                    <Grid item xs={12} id="descripcion_corta-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Descripción corta *</InputLabel>
                        <TextField
                            name="descripcion_corta"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.descripcion_corta}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.descripcion_corta)}
                            onBlur={() => handleBlur("descripcion_corta")}
                        />
                    </Grid>
                    <Grid item xs={12} id="descripcion_larga-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Descripción larga</InputLabel>
                        <TextareaAutosize
                            name="descripcion_larga"
							minRows={3}
                            size="small"
                            style={{ width: "100%" }}
                            value={formik.values.descripcion_larga}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.descripcion_larga)}
                            onBlur={() => handleBlur("descripcion_larga")}
                        />
                    </Grid>
					<Grid item xs={12} id="referencia-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Referencia</InputLabel>
                        <TextField
                            name="referencia"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.referencia}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.referencia)}
                            onBlur={() => handleBlur("referencia")}
                        />
                    </Grid>
					<Grid item xs={12} id="sku-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">SKU</InputLabel>
                        <TextField
                            name="sku"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.sku}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.sku)}
                            onBlur={() => handleBlur("sku")}
                        />
                    </Grid>
                    <Grid item xs={12} id="linea-group" sx={{ mt: "4px", mb: "2px" }}>
						<InputLabel id="text-input-label">línea</InputLabel>
						<Select
							name="linea"
							size="small"
                            sx={{ width: "100%" }}
							value={(formik.values.linea || "").toLowerCase()}
							onChange={formik.handleChange}
							error={Boolean(formik.errors.linea)}
							onBlur={() => handleBlur('linea')}
						>
							{listCategories.map((item) => (
								<MenuItem value={ item?.descripcion.toLowerCase() } key={ item?.uuid }>
									{ item?.descripcion }
								</MenuItem>
							))}
						</Select>
					</Grid>
                    <Grid item xs={12} id="marca-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Marca</InputLabel>
                        <TextField
                            name="marca"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.marca}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.marca)}
                            onBlur={() => handleBlur("marca")}
                        />
                    </Grid>
                    <Grid item xs={12} id="precio_dept-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Precio en tienda</InputLabel>
                        <OutlinedInput
                            name="precio_dept"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.precio_dept}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.precio_dept)}
                            onBlur={() => handleBlur("precio_dept")}
							startAdornment={<InputAdornment position="start">$</InputAdornment>}
                        />
                    </Grid>
                    <Grid item xs={12} id="descuento-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Descuento</InputLabel>
                        <OutlinedInput
                            name="descuento"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.descuento}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.descuento)}
                            onBlur={() => handleBlur("descuento")}
							endAdornment={<InputAdornment position="end">%</InputAdornment>}
                        />
                    </Grid>
                    <Grid item xs={12} id="existencias-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Piezas en existencia:</InputLabel>
                        <OutlinedInput
                            name="existencias"
							type="number"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.existencias}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.existencias)}
                            onBlur={() => handleBlur("existencias")}
							endAdornment={<InputAdornment position="start">pzas.</InputAdornment>}
                        />
                    </Grid>
					<Grid item xs={12} id="vendidos-group" sx={{ mt: "4px", mb: "2px" }}>
                        <InputLabel id="text-input-label">Piezas vendidas:</InputLabel>
                        <OutlinedInput
                            name="vendidos"
							type="number"
                            size="small"
                            sx={{ width: "100%" }}
                            value={formik.values.vendidos}
                            onChange={formik.handleChange}
                            error={Boolean(formik.errors.vendidos)}
                            onBlur={() => handleBlur("vendidos")}
							endAdornment={<InputAdornment position="start">pzas.</InputAdornment>}
                        />
                    </Grid>
					<Grid item xs={12} id="images-group" sx={{ mt: "4px", mb: "2px" }}>
						<InputLabel id="text-input-label">Lista de imagenes</InputLabel>
						<Button
							variant="contained"
							component="label"
							startIcon={<PhotoCamera />}
							sx={{ mb: 4, mt: 3 }}
						>
							Seleccionar Imágenes
							<input
								hidden
								accept="image/*, video/*"
								multiple
								type="file"
								onChange={(event) => handleImageChange(event)}
							/>
						</Button>

						<ImageList sx={{ width: '100%' }} cols={4} rowHeight={100}>
							{selectedImages && selectedImages.map((item, index) => (
								<ImageListItem key={index}>
									<img
										src={item.url}
										alt={`upload-${index}`}
										loading="lazy"
										style={{ height: '100%', objectFit: 'contain', borderRadius: 1 }}
									/>
									<ImageListItemBar
										actionIcon={
											<IconButton
												sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
												onClick={() => handleDelete(index)}
											>
												<Delete />
											</IconButton>
										}
									/>
								</ImageListItem>
							))}
						</ImageList>
					</Grid>
                    <Grid item xs={12} mt={2} sx={{ display: "flex", justifyContent: "center" }}>
                        <Stack
                            direction="row"
                            spacing={1}
                            justifyContent='end'
                            sx={{
                                maxHeight: '2rem',
                                display: 'flex',
                                alignSelf: 'center'
                            }}
                        >
                            <Button key="btn-save" disabled={loading} variant="contained" size="small" color="success" startIcon={<Save />} onClick={() => formik.handleSubmit()}>
								{loading ? <CircularProgress sx={{ width: "25px !important", height: "25px !important", color: "#FFF" }}/> : 'Guardar'}
                            </Button>
                            {edit &&
                                <Button key="btn-new" disabled={loading} variant="contained" size="small" color="info" startIcon={<Add />} onClick={() => handleNew()}>
                                    Nuevo
                                </Button>}
                        </Stack>
                    </Grid>
                </Grid>
				<SnackBarMessage
					severity={snackSeverityArticle}
					message={snackMessageArticle}
					open={snackOpenArticle}
					onClose={() => {
						setSnackOpenArticle(false);
						if (snackSeverityArticle === 'success') {
							handleClose();
						};
					}}
					hideDuration={hideDuration}
				/>
			</Offcanvas.Body>
		</Offcanvas>
	);
};

export default AddArticle;
